import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { allUserRoutes } from '../utils/APIRoutes';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';



export default function Profile() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    async function fetchUserData() {
      const storedUser = JSON.parse(localStorage.getItem('chat-app-user'));

      if (storedUser) {
        try {
          const response = await axios.get(`${allUserRoutes}/${storedUser._id}`);
          setUser(response.data);
        } catch (error) {
          // Handle error, such as redirecting to an error page
          console.error(error);
        }
      } else {
        // User is not logged in, redirect to the login page
        navigate('/login');
      }
    }

    fetchUserData();
  }, [navigate]);

  if (!user) {
    return (
      <div>
        <Container>Loading...</Container>
      </div>
    );
  }

  return (
    <div>
      <Container>
        <h1>Profile</h1>
        <p>Name: {user.username}</p>
        <p>Email: {user.email}</p>
        <p>Password: {user.password}</p>
      </Container>
    </div>
  );
}

const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
  align-items: center;
  background-color: #131324;
  margin-top: 2%;
  color:#fff;
  
  .container {
    align-items: center;
    text-align:start;
    height: 100%;
    min-height:100vh;
    width: 85vw;
    background-color: #00000076;
    display: grid;
    grid-template-columns:  100% ;

    margin: 0 auto;
    padding: 20px;
  }`;